import React from 'react'
import { Trans } from 'react-i18next'

const PageHelp = ({ msgKey, components, values }) => (
  <div className="help-footer">
    <Trans i18nKey={msgKey} components={components} values={values} />
  </div>
)

export default PageHelp